import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '@app/features/auth/auth.service';

/**
 * Guard that checks if the user is logged in.
 */
export function loggedInGuard(redirectTo = '/'): CanActivateFn {
  return async () => {
    const auth0Service = inject(Auth0Service);
    const redirect = inject(Router).createUrlTree([redirectTo]);
    const authService = inject(AuthService);
    const loggedIn = await firstValueFrom(auth0Service.isAuthenticated$);
    if (!loggedIn || !authService.isAuthenticated()) {
      return redirect;
    }
    if (authService.user) {
      return true;
    }
    const user = await firstValueFrom(authService.me()).catch(console.error);
    if (!user) {
      return redirect;
    }
    authService.setUser(user);
    return true;
  };
}
